<template>
    <div>
        <h1>Register</h1>
        <p class="text-surface-500 dark:text-surface-400 block mb-8">Please register with the form below</p>
        <Button type="button" label="Back to Login" @click="showRegister = false"></Button>
        <Divider />
        <div class="mb-8">
            <h2>Username:</h2>
            <InputText v-model="username" placeholder="Username" class="wide"/>
            <h2>Email:</h2>
            <InputText v-model="email" placeholder="Email" />
            <h2>Password:</h2>
            <InputText v-model="password" placeholder="Password" type="password" class="wide"/>
            <h2>Re-enter Password:</h2>
            <InputText v-model="passwordCheck" placeholder="Password" type="password" class="wide"/>
            <Divider />
            <h2>Data Usage Consent</h2>
            <div class="flex-row items-center gap-1">
                <p>
                <!-- For terms and conditions, see: <a @click="router.push('/gdpr')">GDPR</a> page. -->
                    For terms and conditions see our <a href="/gdpr">data policy</a>.
                </p>
                <p>
                Please confirm you are happy for data you enter to be stored in our database, and for session cookies to be stored on your browser.
                </p>
                <Checkbox v-model="gdprAck" label="I acknowledge stuff" binary />
            </div>
            <div class="flex-row items-center gap-1">
                Please accept or refuse optional cookies used for QA and performance monitoring.
                <Checkbox v-model="qaCookies"  binary />
            </div>
        </div>
        <div class="flex items-center mb-8 gap-1">
            <Button type="button" label="Register" @click="register_submit"></Button>
        </div>
        <p class="error" v-if="showInvalidRegisterMessage">Invalid registration</p>
        <p class="error" v-if="showMissingFieldsMessage">Please fill in all fields</p>
        <p class="error" v-if="showPasswordMismatchMessage">Passwords do not match</p>
        <p class="error" v-if="showRegisterError">Error registering</p>
        <p class="error" v-if="showGDPRMessage">Please check the box above to provide consent to our <a href="/gdpr">data policy</a>, which will allow the app to store your registration.</p>
    </div>
</template>

<script setup lang="ts">

import { useAuthStore } from '@/stores/auth'
import { ref } from 'vue'

const authStore = useAuthStore()
const showInvalidRegisterMessage = ref(false)
const showMissingFieldsMessage = ref(false)
const showPasswordMismatchMessage = ref(false)
const showRegisterError = ref(false)
const showGDPRMessage = ref(false)

const showRegister = defineModel<boolean>('showRegister')
const closeDialogPlease = defineModel<boolean>('closeDialogPlease')

const username = ref('')
const password = ref('')
const passwordCheck = ref('')
const email = ref('')
const gdprAck = ref(false)
const qaCookies = ref(false)

const register_submit = async () => {
    showInvalidRegisterMessage.value = false
    showMissingFieldsMessage.value = false
    showPasswordMismatchMessage.value = false
    showRegisterError.value = false
    showGDPRMessage.value = false
    if (username.value === '' || password.value === '' || email.value === '') {
        showMissingFieldsMessage.value = true
        return;
    } 
    if (password.value !== passwordCheck.value) {
        showPasswordMismatchMessage.value = true
        return;
    }
    if (!gdprAck.value) {
        showGDPRMessage.value = true
        return;
    }
    else {
        passwordCheck.value = ''
        showMissingFieldsMessage.value = false
        const SIGNUP_URL = '/api/signup/'
        const response = await fetch(SIGNUP_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                username: username.value,
                password: password.value,
                email: email.value
            })
        }).then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error('Invalid registration')
            }
        }).then(data => {
            authStore.logout()
            console.log(data)
        }).then(() => {
            authStore.login(username.value, password.value)
            password.value = ''
        }).catch(error => {
            showInvalidRegisterMessage.value = true
            console.log(error)
        }).finally(() => {
            showRegister.value = false
            closeDialogPlease.value = false
        })
        // authStore.register(username.value, password.value, email.value).then(() => {
        //     if (authStore.isAuthenticated) {
        //         showInvalidRegisterMessage.value = false
        //     } else {
        //         showInvalidRegisterMessage.value = true
        //     }
        // })
    }
}

</script>

<style scoped>
.error {
    /* Use style built in to primevue */
    color: var(--p-button-text-danger-color);
}
.wide {
    width: 100%;
}
</style>